import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import UploadComponent from '@components/UploadComponent';
import { IField } from '@interfaces/global/config-global';
import { IExportImportTable } from '@interfaces/IExportImportTable';
import ExportImportTableService from '@services/ExportImportTableService';
import ConfigService from '@services/global/Config';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Checkbox, Col, Form, Modal, Row } from 'antd';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import * as React from 'react';

import Table from '../components/TableComponent';
import { LocalStorageKeys } from './App';

export interface IUploadModel3DContainerProps {
  form: any;
  pillar?: any;
}

export interface IUploadModel3DContainerState {
  isLoading: boolean;
  search: string;
  tableData: any,
  filteredTableData: any,
  offset?: string,
  loadingMoreFormflows?: boolean,
  loadingRequest?: boolean,
  serverResponse: any;
  openExportRegister: boolean;
  openImportRegister: boolean;
  extraFields: IField[];
  visibleExtraFieldsIds: string[];
  extraFieldsCheckboxesIds: string[];
  downloadLink: string;
  uploadLink: string;
  canExport: boolean;
  idTable: string;
}

const tableColumns = [{
  title: 'export.table.exportUser',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
  width: '30%'
},
{
  title: 'common.createdAt',
  dataIndex: 'createdAt',
  key: 'createdAt',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '20%'
}];

const _exportService: ExportImportTableService = new ExportImportTableService();
const _configService: ConfigService = new ConfigService();

export default class ExportClass extends React.Component<IUploadModel3DContainerProps, IUploadModel3DContainerState> {

  private idUnit: string;

  constructor(props: IUploadModel3DContainerProps) {
    super(props);

    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
      isLoading: true,
      loadingRequest: false,
      search: '',
      tableData: [],
      filteredTableData: [],
      serverResponse: undefined,
      openExportRegister: false,
      openImportRegister: false,
      extraFields: new Array<IField>(),
      visibleExtraFieldsIds: new Array<string>(),
      extraFieldsCheckboxesIds: new Array<string>(),
      downloadLink: '',
      uploadLink: '',
      canExport: true,
      idTable: ''

    }

    this.getExports = this.getExports.bind(this);
    this.searchEditTables = this.searchEditTables.bind(this);
    this.loadMoreTables = this.loadMoreTables.bind(this);
  }

  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    this.setState({ isLoading: true });
    await this.getExports(true)
    await this.setExtraFieldsState();
  }

  async canExport() {
    const status = this.state.tableData.find((e: any) => e.status === "false")

    if (status !== undefined) {
      this.setState({ canExport: false })
    }
  }

  async getExports(reset: boolean, showLoading?: boolean) {
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const data: any = await _exportService.listAll() || '';
      const dataTableCreate: any = [];
      if(data){
        data.map(async (item: any) => {
          dataTableCreate.push({
            id: item.id,
            name: item.user.name,
            createdAt: item.createdAt,
            status: item.status ? 'true' : 'false',
            action: item.download
          })
        })
      }
      let newDataTableCreate: IExportImportTable[] = [];
      if (!reset) {
        newDataTableCreate = this.state.tableData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      this.setState({
        isLoading: false,
        tableData: newDataTableCreate,
      });
      this.canExport()
    } catch (e) {
      // NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ isLoading: false, loadingMoreFormflows: false });
    }
  }

  onDownload = async (onDownload: any) => {
    const url = onDownload.action;
    let file = document.createElement('a');
    file.href = url;
    file.download = url;
    document.body.appendChild(file);
    file.click();
    document.body.removeChild(file);
  };

  setExtraFieldsState = async () => {
    try {
      const dataGlobal = await _configService.getGLOBAL();


      const extraFields = dataGlobal.userFields;
      this.setState({
        extraFields
      });
      //erro
      const visibleIds: string[] = [];
      extraFields.forEach((extraField: IField) => {
        if (extraField.id) {
          if (Boolean(localStorage.getItem(extraField.id)) === true) { // If true, it's visible
            visibleIds.push(extraField.id);
          }
        }
      });

      this.setState({
        visibleExtraFieldsIds: visibleIds,
        extraFieldsCheckboxesIds: visibleIds,
      });
    } catch (error) {
      console.error("error on fetching extra fields", error)
    }
  }
  toggleExportModal = async () => {
    this.setState({
      openExportRegister: !this.state.openExportRegister,
    });
  }

  toggleImportModal = async (item: any) => {
    this.setState({
      openImportRegister: !this.state.openImportRegister,
      idTable: item.id
    });
  }

  onCheckboxGroupChange = async (evt: any) => {
    this.setState({ extraFieldsCheckboxesIds: evt });
  }

  loadMoreTables() {
    this.setState({ loadingMoreFormflows: true });
    this.getExports(false, false);
  }

  searchEditTables = async (event: any) => {
    event.preventDefault();
    this.setState({
      search: event.target.find.value,
      isLoading: true
    })
    if (event === '') {
      this.setState({
        search: ''
      })
    }
    this.setState({
      isLoading: true,
    })
    this.getExports(true, true);
  }

  //#region upoload model

  handleSubmit = async (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.onSubmitExport();
      } else {
        console.log('Form submit Errors', err)
      }
    });
  }

  onSubmitExport = async () => {
    const { tableData } = this.state;

    const form = this.props.form;

    this.setState({ loadingRequest: true });

    try {
      let nextTableData: IExportImportTable[] = [];
      let values = await form.getFieldsValue();
      let fields: any = []
      if(values.name && values.name.length > 0){
        for (const id of values.name) {
          fields.push({
            type: 1,
            value: id
          })
        }
      }

      values = {
        id: '',
        table: 'user',
        fields: fields
      }
      const response = await _exportService.create(values, this.idUnit);


      nextTableData = [response, ...tableData];
      await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("editables.exportTable"));
      const createData = {
        id: response.id,
        name: response.user.name,
        createdAt: response.createdAt,
        status: response.status ? 'true' : 'false',
        action: response.download
      }
      const element = document.createElement('a');
      element.setAttribute('href', response.download ? response.download : '');
      element.setAttribute('download', 'users.csv');
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      nextTableData = [createData, ...tableData];
      this.setState({ loadingRequest: false, isLoading: false, openExportRegister: false, tableData: nextTableData });
      this.canExport()
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l('common.error'), error);
      this.setState({ loadingRequest: false });
    }
  }

  onSubmitImport = async () => {
    this.setState({ loadingRequest: true });
    const data = {
      upload: this.state.uploadLink
    }
    try {
      await _exportService.importTable(this.state.idTable, data);
      this.setState({ loadingRequest: false, isLoading: false, openImportRegister: false });
      this.canExport()
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("editables.importTable"));
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l('common.error'), error);
      this.setState({ loadingRequest: false, isLoading: false });
    }

  }
  uploadTable = async (fileList: any) => {
    let path = fileList.split('https://')
    this.setState({ uploadLink: path[1] })
  }
  //#endregion
  render() {
    const { getFieldDecorator } = this.props.form;
    const { pillar } = this.props
    let extraFieldsCheckboxesRows: JSX.Element[] = [];

    extraFieldsCheckboxesRows = this.state.extraFields.map((el: any) => {
      return (
        <Col key={el.id} span={24} style={{ marginBottom: "1rem" }}>
          <Checkbox value={el.id}>{el.name}</Checkbox>
        </Col>
      )
    })

    const {
      tableData,
      filteredTableData,
      offset,
      loadingMoreFormflows,
      openExportRegister,
      openImportRegister
    } = this.state;

    return (
      <>
        <p>{I18n.l('editables.labels.description')}</p>
        <p style={{ paddingBottom: '2rem' }} ></p>
        <Toolbar>
          <ToolbarItem>
            <RegisterBtnComponent
              // disabled={this.state.canExport ? false : true}
              onClick={this.toggleExportModal}
              buttonText={I18n.l('editables.labels.registerExport')}
            />
          </ToolbarItem>
        </Toolbar>

        {tableData.length > 0 && (
          <React.Fragment>
            <div className={'goepik-component-tablesize'}>
              <Table
                columns={tableColumns}
                data={filteredTableData.length > 0 ? filteredTableData : tableData}
                noPagination={true}
                showConfirmationModal={false}
                onDownload={this.onDownload}
                // onUpload={this.toggleImportModal}
                downloadLink={this.state.downloadLink}
                pillar={pillar}
              />
            </div>

            {offset && (
              <Button
                className="loading-more"
                type="primary"
                size='large'
                ghost
                loading={loadingMoreFormflows}
                onClick={this.loadMoreTables}>{I18n.l('common.seeMore')}</Button>
            )}
          </React.Fragment>
        )}
        {tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}
        <Modal
          visible={openExportRegister}
          footer={false}
          destroyOnClose={true}
          onCancel={this.toggleExportModal}
        >
          <ModalTitle>{I18n.l('editables.labels.registerExport')}</ModalTitle>
          <React.Fragment >
            <Form hideRequiredMark={true}>
              <Form.Item
                label={I18n.l('editables.labels.selectColumns')}
                colon={false}
              >
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: I18n.l('common.fieldRequired') },],
                  // initialValue: this.state.visibleExtraFieldsIds
                })(
                  <CheckboxGroup
                    onChange={this.onCheckboxGroupChange}
                  >
                    <Row>
                      {extraFieldsCheckboxesRows}
                    </Row>
                  </CheckboxGroup>
                )}
              </Form.Item>
              <Form.Item style={{ textAlign: 'right' }}>
                <Button
                  style={{ marginRight: 8 }}
                  className="link primary bolder"
                  size="large"
                  onClick={this.toggleExportModal}>
                  {I18n.l('common.cancel')}
                </Button>
                <Button loading={this.state.loadingRequest ? true : false} type="primary" htmlType="submit" size="large" onClick={this.handleSubmit}>{I18n.l('common.save')}</Button>
              </Form.Item>
            </Form>
          </React.Fragment>
        </Modal>

        {/* IMPORT TABLES */}
        <Modal
          visible={openImportRegister}
          footer={false}
          destroyOnClose={true}
          onCancel={this.toggleImportModal}
        >
          <ModalTitle>{I18n.l('editables.labels.registerImport')}</ModalTitle>
          <React.Fragment >
            <Form hideRequiredMark={true}>
              <Form.Item
                colon={false}
              >
                {getFieldDecorator('name', {
                  rules: [{ required: false, message: I18n.l('common.fieldRequired') },],
                  // initialValue: this.state.visibleExtraFieldsIds
                })(
                  <UploadComponent
                    directory={'files/data-files'}
                    accept={'.csv'}
                    isStorage={true}
                    customListType={'picture'}
                    validateUpload={this.uploadTable}
                  />
                )}
              </Form.Item>
              <Form.Item style={{ textAlign: 'right' }}>
                <Button
                  style={{ marginRight: 8 }}
                  className="link primary bolder"
                  size="large"
                  onClick={this.toggleImportModal}>
                  {I18n.l('common.cancel')}
                </Button>
                <Button loading={this.state.loadingRequest ? true : false} type="primary" htmlType="submit" size="large" onClick={this.onSubmitImport}>{I18n.l('common.save')}</Button>
              </Form.Item>
            </Form>
          </React.Fragment>
        </Modal>
      </ >
    );
  }
}

const Toolbar = styled.div`
    flex: 0;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    width: 100%;
`;

const ToolbarItem = styled.div`
    flex: 1;
    margin-left: 50px;
    
    &:first-of-type {
        flex: 0;
        margin-left: 0;
    }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

export const ExportContainer = Form.create()(ExportClass);